import api from "../config/api";

export const initiateMRDC = async ({ invoiceId, payload }) => {
  if (!invoiceId) {
    throw new Error("[INITIATE_MRDC] Invoice ID missing.");
  }

  const url = `/platform/mrdc/initiate/invoice/${invoiceId}`;
  const { data } = await api.post(encodeURI(url), payload);

  return data;
};

export const pollMRDC = async ({ id }) => {
  if (!id) {
    throw new Error("[POLL_MRDC] ID missing.");
  }

  const url = `/platform/mrdc/status/poll/${id}`;
  const { data } = await api.get(encodeURI(url));

  return data;
};

export const getMRDCByUser = async ({ userId, status }) => {
  if (!userId) {
    throw new Error("[GET_MRDC_BY_USER] USER ID missing.");
  }

  let query = "";
  if (status) {
    query = `?mrdc_status=${status}`;
  }

  const url = `/platform/mrdc/status/${userId}${query}`;
  const { data } = await api.get(encodeURI(url));

  return data;
};

export const getMRDC = async ({ id }) => {
  if (!id) {
    throw new Error("[GET_MRDC] ID missing.");
  }

  const url = `/platform/mrdc/status/deposit/${id}`;
  const { data } = await api.get(encodeURI(url));

  return data;
};

export const updateMRDC = async ({ id, payload }) => {
  if (!id) {
    throw new Error("[UPDATE_MRDC] ID missing.");
  }

  const url = `/platform/mrdc/${id}`;
  const { data } = await api.patch(encodeURI(url), payload);

  return data;
};

export const updateMRDCMobile = async ({ linkId, imageType, payload }) => {
  if (!linkId) {
    throw new Error("[UPDATE_MRDC_MOBILE] Link ID missing.");
  }

  let query = "";
  if (imageType) {
    query = `?image_type=${imageType}`;
  }

  const url = `/platform/mrdc/mobile${query}`;
  const { data } = await api.patch(encodeURI(url), payload, {
    headers: {
      "x-api-key": linkId,
    },
  });

  return data;
};

export const submitDeposit = async ({ linkId }) => {
  if (!linkId) {
    throw new Error("[SUBMIT_MRDC_MOBILE] Link ID missing.");
  }

  const url = `/platform/mrdc/mobile/submit`;
  const { data } = await api.post(
    encodeURI(url),
    {},
    {
      headers: {
        "x-api-key": linkId,
      },
    }
  );

  return data;
};

export const updateMRDCDevice = async ({ mrdcId, payload }) => {
  if (!mrdcId) {
    throw new Error("[UPDATE_MRDC] ID missing.");
  }

  const url = `/platform/mrdc/${mrdcId}/device`;
  const { data } = await api.patch(encodeURI(url), payload);

  return data;
};

export const sendMRDCLink = async ({
  mrdcId,
  phoneNumber,
  phoneChanged = false,
}) => {
  if (!mrdcId) {
    throw new Error("[SEND_MRDC_LINK] MRDC ID missing.");
  }

  if (!phoneNumber) {
    throw new Error("[SEND_MRDC_LINK] Phone number missing.");
  }

  const url = `/platform/mrdc/link/send/${mrdcId}`;
  const { data } = await api.post(encodeURI(url), {
    phone_number: phoneNumber,
    is_phone_changed: phoneChanged,
  });

  return data;
};

export const validateMRDCLink = async ({ linkId }) => {
  if (!linkId) {
    throw new Error("[VALIDATE_MRDC_LINK] MRDC ID missing.");
  }

  const url = `/platform/mrdc/link/validate/${linkId}`;
  const { data } = await api.get(encodeURI(url));

  return data;
};

export const uploadMRDCCheck = async ({ mrdcId, linkId, checkSide, image }) => {
  const { data: url } = await api.get(
    `/platform/mrdc/mobile/upload/${mrdcId}?file_name=check_${checkSide}.jpeg`,
    {
      headers: {
        "x-api-key": linkId,
      },
    }
  );

  const presignedData = url.uploadURLData;
  const formData = new FormData();

  Object.keys(presignedData.fields).forEach((key) => {
    formData.append(key, presignedData.fields[key]);
  });

  // Convert base64 data URI to Blob without fetch() to avoid CSP connect-src violations
  const [header, base64Data] = image.split(",");
  const mimeMatch = header.match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : "image/jpeg";
  const byteString = atob(base64Data);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: mime });
  formData.append("file", blob, `check_${checkSide}.jpeg`);

  const uploadResponse = await fetch(presignedData.url, {
    method: "POST",
    body: formData,
    redirect: "follow",
  });

  return { url: url, response: uploadResponse };
};
